import React from 'react';
import { string, object, func, arrayOf, shape } from 'prop-types';
import classnames from 'classnames/bind';

import SkinnyItem from './SkinnyItem/SkinnyItem';
import SkinnyDescription from './SkinnyDescription/SkinnyDescription';

import styles from './LandingSkinnyBanner.css';

const cx = classnames.bind(styles);

const LandingSkinnyBanner = ({ title, highlighted, items, description, className, colorScheme }) => {
  try {
    if (items && description) {
      throw Error ('LandingSkinnyBanner is composed by either a list of items or description, not both.');
    }
  }

  catch (err) {
    console.warn(err);
    return null;
  }

  return (
    <section className={cx('wrapper', colorScheme, className, { 'typeB': description } )}>
      <h3 className={styles.title}>
        {title}
        {highlighted && <span className={styles.highlighted}> {highlighted}</span>}
      </h3>
      <div className={styles.container}>
        { items && items.map((item, i) => <SkinnyItem key={`skinnyItem-${i}`} {...item} /> ) }
        { description && <SkinnyDescription {...description} /> }
      </div>
    </section>
  );
};

LandingSkinnyBanner.propTypes = {
  colorScheme: string,
  className: string,
  title: string.isRequired,
  description: shape({
    text: string,
    link: string,
    onClick: func
  }),
  highlighted: string,
  items: arrayOf(shape({
    icon: object,
    description: string
  }))
};

LandingSkinnyBanner.defaultProps = {
  colorScheme: 'lb01',
};

LandingSkinnyBanner.displayName = 'LandingSkinnyBanner';

export default LandingSkinnyBanner;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/SkinnyBanner/Landing/LandingSkinnyBanner.js